<ng-container *ngIf="(hasAccess$ | async) === true">
  <a
    *ngIf="!isExternal"
    class="router-link"
    [routerLink]="url"
    routerLinkActive="router-link-active"
  >
    {{ text }}
  </a>

  <a
    *ngIf="isExternal"
    class="router-link"
    [href]="url | hrefExternal"
    target="_blank"
    rel="noopener noreferrer"
  >
    {{ text }}
  </a>
</ng-container>

<span *ngIf="(hasAccess$ | async) === false">
  {{ text }}
</span>
